// Declare the resource's authority independently of the process's physical region.
export const AWS_PLACEMENT = Object.freeze({
  // Customer execution follows its database: US in primary/edge, serving region in residency.
  regional: 'regional',
  // Shared resources remain in US in every mode.
  global: 'global',
  // Legacy, not yet classified for residency. The resolver refuses this in residency.
  primary: 'primary',
  // The process's own resource, such as its ECS task, in every mode including edge.
  serving: 'serving'
});
